import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import GatedShell from './shell/GatedShell'
import { surfaceByRoute } from './shell/registry'
import { adoptSessionFromUrl } from './shell/auth'

const el = document.getElementById('root')
if (!el) throw new Error('#root not found in index.html')

// The SSO callback lands on /?lv_sso=<jwt> — lift the token into the session
// store and strip it from the address bar BEFORE anything renders, so no
// component ever sees (or leaks) the JWT in the URL.
adoptSessionFromUrl()

// The shell IS the site: `/` and every surface route boot the LV shell. Home
// (the markdown mini-site) is tab zero — always open, always first — so a
// bare '/' lands on Home alone. A surface route additionally opens that
// surface as the active tab (the LMS's *Surface.aspx handoffs keep
// redirecting to the same per-surface URLs). Both are behind the session
// gate: no valid session → the login gate instead of the shell. The
// diagnostics page CapCom's provisioning probes read lives on at `/_diag`
// UNGATED (the probes themselves only call /LearnerView/api/*, and auth is
// not configured on a fresh deployment).
// Surfaces are DISCOVERED from the synced src/surfaces/*/surface.json fragments
// (registry.ts) — the harness holds no surface code; pins live in
// surfaces.config.json and `npm run sync:surfaces` pulls them in.
const path = window.location.pathname.replace(/\/+$/, '') || '/'
const surface = surfaceByRoute(path)

createRoot(el).render(
  <StrictMode>
    {path === '/_diag' ? (
      <App />
    ) : (
      <GatedShell initialSurfaceId={surface?.id} />
    )}
  </StrictMode>,
)
